const utils = require("./utils");

/**
 * Returns a geocoder service implementation depending on which mapping library is loaded
 * @private
 */
function getGeocoderServiceImplementation() {
    return new google.maps.Geocoder();
}

module.exports = {
    getGeocoderServiceImplementation,
};
